// Import moment.js
import moment from 'moment';

export const formatDateToNextDay = (dateString) => {
return moment(dateString).format('YYYY-MM-DD');
};
